/* global $, API */

import { Controller } from 'stimulus';

const $countrySelector = $('.js-billing-country');
const $vatNumber = $('.js-vat-number');

class BillingCountryController extends Controller {
  connect() {
    $('.js-address').on('change', '.js-country-select', () => {
      const value = $countrySelector.val();

      this.allowVatNumber(value)
        .then(data => this.toggleVatNumberField(data.allowVatNumber));
    });
  }

  // eslint-disable-next-line class-methods-use-this
  allowVatNumber(country) {
    return $.ajax({
      url: API.allowVatNumber,
      type: 'GET',
      data: {
        country,
      },
    });
  }

  // eslint-disable-next-line class-methods-use-this
  toggleVatNumberField(allowVatNumber) {
    $vatNumber.toggle(allowVatNumber);
  }
}

export default BillingCountryController;
